const SCREAMING_SNAKE_RUN = /\b[A-Z0-9]+(?:_[A-Z0-9]+)+\b/g;

const ACRONYMS = new Set([
  'API',
  'ARR',
  'CSAT',
  'ETA',
  'KPI',
  'KPIS',
  'MVP',
  'NPS',
  'OKR',
  'OKRS',
  'PTO',
  'QBR',
  'RFC',
  'ROI',
  'SLA',
  'SLAS',
  'SOW',
  'WIP',
]);

const titleCaseSegment = (segment: string): string =>
  segment.length <= 2 || ACRONYMS.has(segment)
    ? segment
    : segment.charAt(0) + segment.slice(1).toLowerCase();

export const humanizeEnums = (text: string): string =>
  text.replace(SCREAMING_SNAKE_RUN, (run) => run.split('_').map(titleCaseSegment).join(' '));

// A signal type is a dotted id like "sprint.dependency_broken". The loop has no frontend-safe signal
// catalog, so this humanizes the id rather than looking up a curated name.
export const humanizeSignalType = (signalType: string): string =>
  signalType
    .split(/[._]/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const humanizeSignalVerdict = (verdict: string): string =>
  verdict.toLowerCase().replaceAll('_', ' ');
